<template>
  <div class="flex flex-col w-full h-full">
    <avatar class="ml-2 self-center" size="full" :user="user" />

    <form class="w-full" @submit.prevent="submit">
      <nx-file-input
        :errors="form.errors"
        label="Avatar"
        id="avatar"
        accept="image/*"
        @input="input"
        info="Avatars should be square. Any non-square avatars will be cropped to be square."
      ></nx-file-input>

      <nx-button
        native-type="submit"
        v-if="avatar"
        type="primary"
        :disabled="loading"
      >{{ loading ? 'Loading..' : 'Upload Avatar' }}</nx-button>
    </form>

    <div>
      <nx-button
        class="mt-2"
        type="secondary"
        :disabled="loading"
        v-if="user.avatar"
        @click="destroy"
      >{{ loading ? 'Loading..' : 'Remove Avatar' }}</nx-button>
    </div>
  </div>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "UserAvatarForm",
  props: {
    user: {
      required: true
    }
  },
  data() {
    return {
      avatar: null,
      form: new Form(),
      loading: false,
      size: true
    }
  },
  methods: {
    input(file) {
      this.avatar = file
      this.form.errors.clear('avatar')
    },
    async submit() {
      this.loading = true
      await this.$api.self
        .avatar({ avatar: this.avatar })
        .then(() => {
          this.$toasted.success("Your avatar has been updated.")
          this.avatar = null
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
      this.loading = false
    },
    async destroy() {
      this.loading = true
      await this.$api.self
        .avatar({})
        .then(() => {
          this.$toasted.success("Your avatar has been removed.")
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
      this.loading = false
    }
  }
}
</script>
